import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const ScreenshotService = {
    async saveAsPdf(target, filename = 'kalkulacio.pdf', options = {}) {
        const {
            hideClass = 'pdf-hidden',
            orientation = 'l',
            quality = 'medium',
            html2canvasOptions = {},
        } = options;

        let scale;
        let jpegQuality;
        switch (quality) {
            case 'low':
                scale = 1;
                jpegQuality = 0.7;
                break;
            case 'high':
                scale = 2;
                jpegQuality = 0.92;
                break;
            case 'medium':
            default:
                scale = 1.5;
                jpegQuality = 0.85;
                break;
        }

        let element = target;
        if (typeof target === 'string') {
            element = document.querySelector(target);
        }
        if (!element) {
            return Promise.reject(new Error('Target element not found'));
        }

        const canvas = await html2canvas(element, {
            useCORS: true,
            scale,
            backgroundColor: '#ffffff',
            scrollX: 0,
            scrollY: -window.scrollY,
            ignoreElements: (el) => {
                return el.classList && el.classList.contains(hideClass);
            },
            onclone: (clonedDoc) => {
                clonedDoc.body.classList.add('pdf-desktop');

                clonedDoc.querySelectorAll('.pdf-color-target').forEach((el) => {
                    el.style.color = '#0D2A50';
                    el.style.paddingLeft = '24px';
                });
            },
            ...html2canvasOptions,
        });

        const imgData = canvas.toDataURL('image/jpeg', jpegQuality);

        const pdf = new jsPDF({
            orientation,
            unit: 'mm',
            format: 'a4',
            compress: true,
        });

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const ratio = Math.min(
            pageWidth / canvas.width,
            pageHeight / canvas.height
        );

        const imgWidth = canvas.width * ratio;
        const imgHeight = canvas.height * ratio;

        const x = (pageWidth - imgWidth) / 2;
        const y = 12;

        pdf.addImage(imgData, 'JPEG', x, y, imgWidth, imgHeight);

        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const baseName = filename.replace(/\.pdf$/i, '');
        const finalFilename = `${baseName}-${year}-${month}-${day}.pdf`;

        pdf.save(finalFilename);
    },
};

export default ScreenshotService;
